import { Shield, Scale, AlertTriangle, FileText, CheckCircle, Phone } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CTASection from "@/components/CTASection";
import QuickContact from "@/components/QuickContact";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { criminalContent } from "@/i18n/criminal-content";
import SEO from "@/components/SEO";

const DWI = () => {
  const { language } = useLanguage();
  const content = criminalContent.dwi[language];

  return (
    <div className="min-h-screen">
      <SEO title={content.title} description={content.subtitle} useMapping={false} />
      <Header />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center bg-gradient-hero text-primary-foreground">
        <div className="container mx-auto px-4 relative z-10 text-center">
          <Shield className="h-20 w-20 mx-auto mb-6 text-accent" />
          <h1 className="text-5xl md:text-6xl font-bold mb-6">{content.title}</h1>
          <p className="text-xl mb-8 max-w-3xl mx-auto opacity-95">
            {content.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" variant="hero">
              <Link to="/appointment">Schedule Consultation</Link>
            </Button>
            <a href="tel:8329303059">
              <Button size="lg" variant="outline" className="border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
                <Phone className="mr-2 h-5 w-5" />
                Call: (832) 930-3059
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold mb-8">{content.sections[0].title}</h2>
            <p className="text-lg text-muted-foreground mb-6">
              {content.sections[0].content}
            </p>

            <div className="bg-card p-8 rounded-lg shadow-lg mb-12">
              <h3 className="text-2xl font-bold mb-4">We Defend Against All DWI Charges:</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  "First-Time DWI",
                  "Second & Third DWI",
                  "Felony DWI",
                  "DWI with Child Passenger",
                  "Intoxication Assault",
                  "Intoxication Manslaughter",
                  "Boating While Intoxicated (BWI)",
                  "Commercial Driver DWI"
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <CheckCircle className="h-5 w-5 text-accent flex-shrink-0" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <QuickContact 
        title="Arrested for DWI? Act Fast."
        description="Time is critical in DWI cases. Call us now for aggressive defense representation."
      />

      <CTASection 
        title="Don't Face DWI Charges Alone"
        description="Your future is too important to leave to chance. Contact Daniel Albert Law Firm today."
      />
      <Footer />
    </div>
  );
};

export default DWI;